import request from "../request";

export default {
  // 列表
  lists(data) {
    return request.get("/adminUser/lists", data);
  },
  
  //添加
  add(data) {
    return request.post("/adminUser/add", data);
  },
  
  // 编辑
  edit(data) {
    return request.post("/adminUser/edit", data);
  },
  
  // 删除
  delete(data) {
    return request.post("/adminUser/delete", data);
  },
	
	// 管理员信息
	info(data) {
		return request.get("/admin/getAdminInfo", data);
	},
	
	
};
